/**
 * RTL emotion cache.
 *
 * Used when language is Persian (fa). Adds the stylis-plugin-rtl
 * plugin so that Material-UI styles are flipped (margin-left ↔
 * margin-right, etc.).
 */

import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

export const rtlCache = createCache({
  key: 'mui-rtl',
  stylisPlugins: [prefixer, rtlPlugin],
});
